export enum LinkType {
  Default = 'default',
  External = 'external',
}

export enum LinkSize {
  Sm = 'sm',
  Md = 'md',
  Lg = 'lg',
}
